/* eslint-disable */
(function (window) {
    window.recaptchaData = window.recaptchaData || {};
    window.recaptchaData.recaptchaEventsHolder = window.recaptchaData.recaptchaEventsHolder || {};
    window.recaptchaData.recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr || [];

    window.onRecaptchaLoad = function () {
        var recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr;
        for (var i = 0; i < recaptchaCallbacksArr.length; i += 1) {
            if (typeof recaptchaCallbacksArr[i] === 'function') {
                recaptchaCallbacksArr[i]();
            }
        }
        window.recaptchaData.recaptchaCallbacksArr = [];
    };
}(window));
/* eslint-enable */

/**
 * Injects the Google reCAPTCHA script tag exactly once (flag shared across all
 * bundled copies of this module via window.recaptchaData).
 *
 * PRIVACY/CONSENT NOTE (GDPR/CPRA data minimization): this is deliberately NOT
 * called on page load — only when the shopper starts interacting with a
 * protected form (see attach) or at an explicit risk-triggered moment.
 */
function loadScript() {
    if (window.grecaptcha || window.recaptchaData.scriptRequested) {
        return;
    }
    window.recaptchaData.scriptRequested = true;

    var url = window.SitePreferences.RECAPTCHA_API_URL;
    var script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}

module.exports = {
    /**
     * Kept as a no-op so existing call sites need no changes. The Google
     * script is no longer loaded at page load; loading is deferred until the
     * shopper interacts with an attached form.
     */
    init: function () {
        // intentionally empty — loading is interaction-triggered (see attach/loadScript)
    },

    loadScript: loadScript,

    attach: function (form, callback) {
        window.recaptchaData.recaptchaCallbacksArr.push(function () {
            var $holder = form.find('.js-recaptcha-input')[0];
            var holderId = window.grecaptcha.render($holder, {
                sitekey: window.SitePreferences.RECAPTCHA_SITE_KEY,
                theme: 'light',
                size: 'invisible',
                badge: 'bottomright',
                isolated: true,
                callback: typeof callback === 'function' ? callback : null
            });
            window.recaptchaData.recaptchaEventsHolder[form.attr('name')] = holderId;
        });

        if (window.grecaptcha) {
            // Script already present (another protected form triggered it):
            // render immediately.
            window.onRecaptchaLoad();
        } else {
            // Defer the Google request until the shopper actually starts the
            // protected action (first focus/typing in the form).
            form.off('focusin.recaptcha change.recaptcha')
                .one('focusin.recaptcha change.recaptcha', function () {
                    loadScript();
                });
        }
    },

    showReCaptcha: function (formName) {
        if (window.grecaptcha && formName && formName in window.recaptchaData.recaptchaEventsHolder) {
            window.grecaptcha.execute(window.recaptchaData.recaptchaEventsHolder[formName]);
            return;
        }

        // Widget not rendered yet (e.g. instant autofill + submit before any
        // focus event, or the script is still in flight): queue the challenge
        // to run right after the pending render callbacks, then load.
        window.recaptchaData.recaptchaCallbacksArr.push(function () {
            if (formName && formName in window.recaptchaData.recaptchaEventsHolder) {
                window.grecaptcha.execute(window.recaptchaData.recaptchaEventsHolder[formName]);
            }
        });
        loadScript();
    }

};
